var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-30"},[_vm._v("Шаблоны")]),_c('NavTabsSwiper',{attrs:{"tabs-list":_vm.tabs}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }